import { routes } from '../../lib/routes';
import { DevicesTestingStatusMeta, SerializedDevicesTestingRecord } from '../../model/devicesTestingForm';
import { callApi } from '../utils';

export const getDevicesTestingRecordStatus = (skillId: string) => {
    return callApi<DevicesTestingStatusMeta>({
        method: 'GET',
        url: routes.app.api(`/skills/${skillId}/testing-date/status`),
    });
};

export const saveDevicesTestingOptions = (skillId: string, body: SerializedDevicesTestingRecord) => {
    return callApi<SerializedDevicesTestingRecord>({
        method: 'POST',
        url: routes.app.api(`/skills/${skillId}/testing-date`),
        data: body,
    });
};
